import type { LucideIcon } from 'lucide-react';
import { forwardRef, type InputHTMLAttributes } from 'react';

import { cn } from '../lib/cn';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
    icon?: LucideIcon;
}

const baseClasses =
    'flex h-10 w-full rounded-md border border-solid border-gray-300 bg-white py-2 text-sm text-gray-900 placeholder:text-gray-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:border-transparent disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100 dark:placeholder:text-gray-500';

export const Input = forwardRef<HTMLInputElement, InputProps>(
    ({ className, type = 'text', icon: Icon, ...props }, ref) => {
        if (!Icon) {
            return (
                <input
                    ref={ref}
                    type={type}
                    className={cn(baseClasses, 'px-3', className)}
                    {...props}
                />
            );
        }
        return (
            <div className="relative w-full">
                <Icon
                    aria-hidden="true"
                    className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400"
                />
                <input
                    ref={ref}
                    type={type}
                    className={cn(baseClasses, 'pl-9 pr-3', className)}
                    {...props}
                />
            </div>
        );
    },
);
Input.displayName = 'Input';
